// extracted by mini-css-extract-plugin
export default {"overflowBox":"ProjectedBalanceFieldTable_overflowBox__GGjb6","container":"ProjectedBalanceFieldTable_container__YNnw6"};